import { render } from "./PresentationSlideThree.vue?vue&type=template&id=f08410d8&scoped=true"
const script = {}

import "./PresentationSlideThree.vue?vue&type=style&index=0&id=f08410d8&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f08410d8"]])

export default __exports__